import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  public errorSubject = new Subject();

  constructor() { }

  injectonSubject(data) {
    this.errorSubject.next(data);
  }

}
